import { Fragment } from "react";
import Navbar from "CommonComponents/Navbar/Navbar";
import FooterA from "Pages/Home/FooterA/FooterA";
import FooterB from "Pages/Home/FooterB/FooterB";
import HeroImage from "./HeroImage/HeroImage";
import AllBlogs from "./AllBlogs/AllBlogs";

const Blogs = () => {
  return (
    <Fragment>
      <header>
        <Navbar />
      </header>
      <main>
        <HeroImage />
        <AllBlogs />
      </main>
      <footer>
        <FooterA />
        <FooterB />
      </footer>
    </Fragment>
  );
};

export default Blogs;
